import { t } from '../../utils/i18n';
import { getErrorMessageKey } from './getErrorMessageKey';

export { getErrorMessageKey };

export const mapErrorCodeToMessage = (
  errorCode: string,
  params?: {
    isMerchantContext?: boolean;
    messageParams?: {
      [param: string]: string;
    };
  }
): string => {
  const { isMerchantContext, messageParams = {} } = params || {};
  const key = getErrorMessageKey(errorCode, isMerchantContext);
  const message = t(key, messageParams);

  if (message && message !== key) {
    return message;
  }

  return '';
};

export enum ServerErrorCode {
  // Mapped to "This payment provider is not available at the moment. Please try again in a few minutes."
  Default = '999',
  BuyerCanceled = '3030',
  Failed3DS = '3004',
}
